

const SET_EMPRESA = (state,empresa) => {
	state.logged = empresa
}

const SET_PERIODICO = (state, periodico) => {
	state.periodico = periodico
}

export{
	SET_EMPRESA,
	SET_PERIODICO
}



// WEBPACK FOOTER //
// ./src/store/empresa/mutations.js